module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJlODI5NjA1ZDdkMmMzZGQ3Y2FjYTRjNjI5ZGM2NWJlZS5zdmciOw=="